import {
  ApiResponse,
  ParcelPromocodesResponseData,
} from '../models/apiResponse';
import { apiRequests as requests } from './http-client';

const Promocodes = {
  promocodes: (shipmentId: number, promocode: string) =>
    requests
      .put<
        ApiResponse<ParcelPromocodesResponseData>
      >(`/v1/shipment/${shipmentId}/promocodes`, { promocode })
      .then((response) => response.data?.shipment),
  deletePromocode: (shipmentId: number, promocodeId: number) =>
    requests
      .del<
        ApiResponse<ParcelPromocodesResponseData>
      >(`/v1/shipment/${shipmentId}/promocodes/${promocodeId}`)
      .then((response) => response.data?.shipment),
};

export default Promocodes;
